module.exports = __webpack_public_path__ + "static/assets/f8da4de4650ed9401828d7288e406162.gif";